import type { ComponentProps } from 'react';

import UserModal from '../../organisms/UserModal/index.jsx';
import type { HandleSubmitPramsType } from '../../organisms/UserModal/userModal.types.js';
import {
  useUserInviteOperation,
  type UserInviteOperation,
} from './useUserInviteOperation.js';

type Props = Omit<
  ComponentProps<typeof UserModal>,
  'onSubmit' | 'onEmailCheckStart' | 'onEmailCheckError'
> & {
  isAgGridEnabled: boolean;
  onSubmit: (
    params: HandleSubmitPramsType,
    inviteOperation: UserInviteOperation,
  ) => Promise<null | undefined>;
};

// The "New user" modal. It mounts when "New user" opens it and unmounts when
// it closes, so the `user.invite` operation lives exactly as long as it.
const NewUserModal = ({ isAgGridEnabled, onSubmit, ...props }: Props) => {
  const inviteOperation = useUserInviteOperation(isAgGridEnabled);

  return (
    <UserModal
      {...props}
      onSubmit={(params) => onSubmit(params, inviteOperation)}
      onEmailCheckStart={inviteOperation.restartIfEnded}
      onEmailCheckError={() => inviteOperation.fail('email-check')}
    />
  );
};

export default NewUserModal;
